import { baseApi } from '@/lib/api/baseApi';
import { AiPrivilege } from '@/types/login';

import { Builder } from '../commonApiType/apiBuilderTypes';
import { getPrivileges } from '../constants';
export const privilegeApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    getAllResultConfig: builder.query<AiPrivilege, void>({
      query: () => ({
        url: getPrivileges,
      }),
    }),
    updateTokenCount: builder.mutation({
      query: ({ totalTokens, projectid }) => ({
        url: `/appmanagement/optimize/v1/license/token-validations?usedTokens=${totalTokens}`,
        method: 'PUT',
        headers: { projectid: String(projectid) },
      }),
    }),
  }),
});
export const {
  useGetAllResultConfigQuery,
  useLazyGetAllResultConfigQuery,
  useUpdateTokenCountMutation,
} = privilegeApi;
export default privilegeApi;
